import { render, staticRenderFns } from "./print-correspondence.vue?vue&type=template&id=1995e338&scoped=true"
import script from "./print-correspondence.vue?vue&type=script&lang=js"
export * from "./print-correspondence.vue?vue&type=script&lang=js"
import style0 from "./print-correspondence.vue?vue&type=style&index=0&id=1995e338&lang=scss"
import style1 from "./print-correspondence.vue?vue&type=style&index=1&id=1995e338&scoped=true&lang=scss"
import style2 from "./print-correspondence.vue?vue&type=style&index=2&id=1995e338&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1995e338",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1995e338')) {
      api.createRecord('1995e338', component.options)
    } else {
      api.reload('1995e338', component.options)
    }
    module.hot.accept("./print-correspondence.vue?vue&type=template&id=1995e338&scoped=true", function () {
      api.rerender('1995e338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/components/print-correspondence.vue"
export default component.exports